import React, { useState, useRef, useEffect } from 'react';
import './OtpInput.css';

interface OtpInputProps {
  length?: number;
  value: string;
  onChange: (value: string) => void;
  error?: boolean;
}

const OtpInput: React.FC<OtpInputProps> = ({ length = 6, value, onChange, error }) => {
  const [otp, setOtp] = useState<string[]>(new Array(length).fill(""));
  const inputRefs = useRef<(HTMLInputElement | null)[]>([]);

  useEffect(() => {
    if (value === "" && otp.some(v => v !== "")) {
      setOtp(new Array(length).fill(""));
    }
  }, [value, length]);

  const handleChange = (element: React.ChangeEvent<HTMLInputElement>, index: number) => {
    if (isNaN(Number(element.target.value))) return false;

    const newOtp = [...otp];
    newOtp[index] = element.target.value.substring(element.target.value.length - 1);
    setOtp(newOtp);
    onChange(newOtp.join(""));

    if (element.target.value && index < length - 1 && inputRefs.current[index + 1]) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, index: number) => {
    if (e.key === "Backspace") {
      if (!otp[index] && index > 0 && inputRefs.current[index - 1]) {
        const newOtp = [...otp];
        newOtp[index - 1] = "";
        setOtp(newOtp);
        onChange(newOtp.join(""));
        inputRefs.current[index - 1]?.focus();
      } else {
        const newOtp = [...otp];
        newOtp[index] = "";
        setOtp(newOtp);
        onChange(newOtp.join(""));
      }
    }
  };

  const handlePaste = (e: React.ClipboardEvent) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text/plain").slice(0, length);
    if (!/^\d+$/.test(pastedData)) return;

    const newOtp = [...otp];
    pastedData.split("").forEach((char, index) => {
      newOtp[index] = char;
    });
    setOtp(newOtp);
    onChange(newOtp.join(""));
    
    const focusIndex = Math.min(pastedData.length, length - 1);
    if (inputRefs.current[focusIndex]) {
        inputRefs.current[focusIndex]?.focus();
    }
  };

  return (
    <div className="otp-container">
      {otp.map((data, index) => (
        <input
          className={`otp-box ${error ? 'otp-error' : ''}`}
          type="text"
          name="otp"
          maxLength={1}
          key={index}
          value={data}
          onChange={e => handleChange(e, index)}
          onKeyDown={e => handleKeyDown(e, index)}
          onPaste={handlePaste}
          ref={ref => { inputRefs.current[index] = ref; }}
          autoComplete="one-time-code"
        />
      ))}
    </div>
  );
}

export default OtpInput;
